import { GATEWAY_MANIFEST } from '../../constants/gateways';
import type { CountryCode, GatewayManifestEntry } from './types';

/**
 * The query layer over the gateway manifest. The manifest itself is data
 * and lives in src/constants/gateways.ts — everything in the app reads it
 * through these two functions rather than filtering the array itself, so
 * "which gateway runs where" has exactly one answer and one place to
 * change it.
 */
export function getGatewaysForCountry(
  country: CountryCode
): GatewayManifestEntry[] {
  return GATEWAY_MANIFEST.filter((entry) => entry.countries.includes(country));
}

export function getGatewayById(id: string): GatewayManifestEntry | undefined {
  return GATEWAY_MANIFEST.find((entry) => entry.id === id);
}
